import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationState } from '../types';
import { FEATURE_NAME_CORE } from '../reducer/core.reducer';

export const getCoreState =
  createFeatureSelector<ApplicationState>(FEATURE_NAME_CORE);

export const getGtmIsEnabled = (state: ApplicationState): boolean =>
  state?.gtmEnabled || false;

export const selectGtmIsEnabled = createSelector(getCoreState, getGtmIsEnabled);
